export const ArrowDownLongIcon = () => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 0.459351L9 10.8957L12.8625 7.15026L15 9.18662L7.5 16.4593L-2.79009e-07 9.18662L2.1375 7.15026L6 10.8957L6 0.459351L9 0.459351Z" />
    </svg>
  );
};
